import React from 'react';
import { SoloLegalLayout } from '../components/SoloLegalLayout';

const AboutPage = () => (
  <SoloLegalLayout title="About SEN-Education">
    <p className="text-gray-700 dark:text-gray-300">
      <strong>This is the official website of SEN-Education</strong>, a product of <strong>The Send Tech Company Ltd</strong> (SEN-Ed is a trading name). We provide SEND support tools for parents, home educators, teachers and tutors in the UK. This site is for adults only; it is not intended for use by children directly.
    </p>
    <p className="text-gray-700 dark:text-gray-300">
      <strong>Legal entity:</strong> The Send Tech Company Ltd. Company number 16756429. Registered in England and Wales. You can verify our registration at{' '}
      <a href="https://find-and-update.company-information.service.gov.uk/company/16756429" rel="noopener noreferrer" className="text-purple-600 hover:text-purple-700 dark:text-purple-400 dark:hover:text-purple-300 underline">
        Companies House
      </a>.
    </p>
    <p className="text-gray-700 dark:text-gray-300">
      <strong>Registered office:</strong> 167-169 Great Portland Street, London, England, W1W 5PF.
    </p>
    <p className="text-gray-700 dark:text-gray-300">
      <strong>How to verify us:</strong>{' '}
      <a href="https://find-and-update.company-information.service.gov.uk/company/16756429" rel="noopener noreferrer" className="text-purple-600 hover:text-purple-700 dark:text-purple-400 dark:hover:text-purple-300 underline">
        Companies House
      </a>{' '}
      (company 16756429), <a href="/.well-known/security.txt" className="text-purple-600 hover:text-purple-700 dark:text-purple-400 dark:hover:text-purple-300 underline">security.txt</a>, and{' '}
      <a href="mailto:contact@sen-ed.co.uk" className="text-purple-600 hover:text-purple-700 dark:text-purple-400 dark:hover:text-purple-300 underline">contact@sen-ed.co.uk</a>.
    </p>
  </SoloLegalLayout>
);

export default AboutPage;
